import api from './BaseApi';

export const getCategories = async (params = {}) => {
    try {
        const response = await api.get('/admin/category', { params });
        return response.data;
    } catch (error) {
        console.error('Get Categories error:', error);
        throw error;
    }
};

export const getCategoryById = async (id) => {
    try {
        const response = await api.get(`/admin/category/${id}`);
        return response.data;
    } catch (error) {
        console.error('Get Category error:', error);
        throw error;
    }
};

export const createCategory = async (data) => {
    try {
        const response = await api.post('/admin/category', data);
        return response; 
    } catch (error) {
        console.error('Create Category error:', error);
        throw error;
    }
};

export const updateCategory = async (id, payload) => {
    try {
        const response = await api.put(`/admin/category/${id}`, payload);
        return response; 
    } catch (error) {
        console.error('Update Category error:', error);
        throw error;
    }
};

export const deleteCategory = async (id) => {
    try {
        const response = await api.delete(`/admin/category/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete Category error:', error);
        throw error;
    }
};

export const toggleCategoryStatus = async ({ id, status }) => {
    try {
        const response = await api.patch(`/admin/category/${id}/status`, { status });
        return response; 
    } catch (error) {
        console.error('Toggle Category Status error:', error);
        throw error;
    }
};

export const getTypesList = async () => {
    try {
        const response = await api.get('/admin/category-types');
        return response.data;
    } catch (error) {
        console.error('Get Category Types error:', error);
        throw error;
    }
};